var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"30%","float":"left","text-align":"right"}},[_c('div',[_vm._v(_vm._s(_vm.leftText))])]),_c('div',{staticStyle:{"width":"70%","float":"left","padding-left":"10px"}},[_c('div',[_vm._v(_vm._s(_vm.rightText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }